import {UI} from "../../../../../../../stem-core/src/ui/UIBase.js";
import {ensure} from "../../../../../../../stem-core/src/base/Require.js";
import {apiClient} from "../../../../../../../client/connection/BlinkApiClient.js";

const PAYPAL_BUTTON_ID = "paypal-button-container";

function MakePayPalSDKURL(clientId) {
    return "https://www.paypalobjects.com/api/checkout.js";

    const disableFunding = "card,credit,paylater,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo";
    return `https://www.paypal.com/sdk/js?client-id=${clientId}&components=buttons&intent=authorize&commit=false&disable-funding=${disableFunding}&integration-date=2022-07-07&vault=true`;
}


export class PayPalWidget extends UI.Element {
    render() {
        return [
            <div id={PAYPAL_BUTTON_ID} style={{height: 42}} />,
        ]
    }

    insertButtons() {
        const {paymentProcessor} = this.options;
        const paypalClientId = paymentProcessor.publicKey;

        const {paypal} = window;

        paypal.Button.render({
            env: paymentProcessor.publicConfig?.sandbox ? "sandbox" : "production",
            client: {
                sandbox: paypalClientId,
                production: paypalClientId,
            },
            style: {
                layout: "horizontal",
                color: "white",
                shape: "rect",
                label: "paypal",
                size: "large",
                tagline: false,
                height: 42,
                funding: {
                    allowed: ["paypal.FUNDING.CARD"],
                    disallowed: ["paypal.FUNDING.CREDIT"]
                }
            },
            payment: async (data, actions) => {
                const response = await apiClient.post("/external_providers/create_paypal_billing_agreement", {
                    merchantId: paymentProcessor.merchantId,
                });
                return response.tokenId;
            },
            onApprove: (data, actions) => {
            	const {onApprove} = this.options;
                console.warn("Approve", data, actions);
                onApprove(data);
            }

        }, "#" + PAYPAL_BUTTON_ID);
    }

    onMount() {
        const {paymentProcessor} = this.options;
        const paypalClientId = paymentProcessor.publicKey;
        const paypalURL = MakePayPalSDKURL(paypalClientId);

        ensure(paypalURL, () => {
            this.insertButtons();
        });
    }
}
